export function getRuntimeConfig() {
  const runtime = globalThis.__ASK_STOICS_CONFIG__ || {}
  return {
    apiOrigin: runtime.apiOrigin ?? import.meta.env.VITE_API_ORIGIN ?? '',
    firebaseApiKey: runtime.firebaseApiKey ?? import.meta.env.VITE_FIREBASE_API_KEY,
    firebaseAuthDomain: runtime.firebaseAuthDomain ?? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    firebaseProjectId: runtime.firebaseProjectId ?? import.meta.env.VITE_FIREBASE_PROJECT_ID,
    firebaseStorageBucket: runtime.firebaseStorageBucket ?? import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    firebaseMessagingSenderId: runtime.firebaseMessagingSenderId ?? import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    firebaseAppId: runtime.firebaseAppId ?? import.meta.env.VITE_FIREBASE_APP_ID,
    firebaseMeasurementId: runtime.firebaseMeasurementId ?? import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
    revenueCatIosApiKey: runtime.revenueCatIosApiKey ?? import.meta.env.VITE_REVENUECAT_IOS_API_KEY,
    revenueCatAndroidApiKey: runtime.revenueCatAndroidApiKey ?? import.meta.env.VITE_REVENUECAT_ANDROID_API_KEY,
    sentryDsn: runtime.sentryDsn ?? import.meta.env.VITE_SENTRY_DSN ?? '',
    buildSha: runtime.buildSha ?? import.meta.env.VITE_BUILD_SHA ?? 'local',
    appEnvironment: runtime.appEnvironment ?? import.meta.env.VITE_APP_ENV ?? 'local'
  }
}

export async function loadWebRuntimeConfig() {
  try {
    const response = await fetch('/api/runtime-config', { cache: 'no-store' })
    if (!response.ok) return
    globalThis.__ASK_STOICS_CONFIG__ = await response.json()
  } catch {
    // Local Vite preview can operate without provider configuration.
  }
}
